enum Domain {
    DCA = "inindca.com",
    TCA = "inintca.com",
    COM = "mypurecloud.com",
    USW2 = "usw2.pure.cloud",
    AU = "mypurecloud.com.au",
    IE = "mypurecloud.ie",
    JP = "mypurecloud.jp",
    DE = "mypurecloud.de",
    APNE2 = "apne2.pure.cloud",
    CAC1 = "cac1.pure.cloud",
    EUW2 = "euw2.pure.cloud",
    APS1 = "aps1.pure.cloud",
    SAE1 = "sae1.pure.cloud",
    APNE3 = "apne3.pure.cloud",
    MEC1 = "mec1.pure.cloud",
    EUC2 = "euc2.pure.cloud",
    APSE1 = "apse1.pure.cloud",
    GOVUSE2 = "use2.us-gov-pure.cloud",
    MAXIMUS = "use2.maximus-pure.cloud",
    MXC1 = "mxc1.pure.cloud",
    WILDCARD = ".*",
}

export default Domain;
